<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          class="no-before"
          clearable
          :value="order_name"
          label="Nom de commande"
          hint="Laisser vide pour utiliser le nom"
          persistent-hint
          @change="v => $emit('update:order_name', v)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          class="no-before"
          clearable
          :value="order_number"
          label="Numéro de commande"
          @change="v => $emit('update:order_number', v)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <RecipeProductAllergenInput
          :value="allergens"
          @input="v => $emit('update:allergens', v)"
        ></RecipeProductAllergenInput>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import { rulesMixin } from "@/mixins/rulesMixins";
import RecipeProductAllergenInput from "./RecipeProductAllergenInput";
export default {
  mixins: [rulesMixin],
  name: "RecipeProductFields",
  components: {
    RecipeProductAllergenInput
  },
  props: {
    nom: {
      required: true
    },
    order_number: {
      required: true
    },
    order_name: {
      required: true
    },
    product_key: {
      required: true
    },
    display_order: {
      required: true
    },
    est_intermediaire: {
      type: Boolean,
      required: true
    },
    allergens: {
      type: Array,
      required: true
    },
    is_pinned: {
      type: Boolean,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits", "getAllowedUnits"]),
    getIsPinnedModel: {
      get() {
        return this.is_pinned;
      },
      set(v) {
        this.$emit("update:is_pinned", v);
      }
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>
